<template>
	<v-container fluid>
		<v-row v-if="$myStore.state.user.user_role_id == 1">
			<v-col cols="2">
				<v-btn color="primary" @click="addClick">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addMember') }}
				</v-btn>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="2" class="d-flex justify-end">
				<v-btn color="primary" @click="bulkStatusChangeClick"> Izmjena statusa </v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12"
				><v-row class="pl-3 mb-2">
					<v-btn
						small
						:color="fastFilterCountry == 0 ? 'primary' : ''"
						@click="fastFilterCountry = 0"
						class="mr-2"
						>Svi</v-btn
					>
					<v-btn
						small
						:color="fastFilterCountry == 1 ? 'primary' : ''"
						@click="fastFilterCountry = 1"
						class="mr-2"
						>Hrvatska</v-btn
					>
					<v-btn
						small
						:color="fastFilterCountry == 3 ? 'primary' : ''"
						@click="fastFilterCountry = 3"
						class="mr-2"
						>BiH</v-btn
					>
					<v-btn
						small
						:color="fastFilterCountry == 99 ? 'primary' : ''"
						@click="fastFilterCountry = 99"
						class="mr-2"
						>Inozemstvo</v-btn
					>
				</v-row>
				<v-card flat outlined>
					<v-card-text>
						<v-row>
							<v-col>
								<TheTable
									:additional-filters="membersTable.additionalFilters"
									:default-sort="membersTable.defaultSort"
									:excel="true"
									:fields="membersTable.headers"
									:header-selection-key="'members-headers'"
									:filter-save-key="'members-filters'"
									:height="membersTable.height"
									:total-records="membersTable.total"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in membersTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="membersTable.selectedHeaders.includes('full_name')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.full_name != null">{{ item.full_name }}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="membersTable.selectedHeaders.includes('membership_id')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.membership_id != null">{{ item.membership_id }}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="membersTable.selectedHeaders.includes('email')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.email != null">{{ item.email }}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="membersTable.selectedHeaders.includes('phone_number')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.mobile_phone_number != null">{{
												item.mobile_phone_number
											}}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="membersTable.selectedHeaders.includes('branch_id_single')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.branch != null">{{ item.branch.name }}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="membersTable.selectedHeaders.includes('magazine_id_single')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.magazine != null">{{ item.magazine.name }}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="
												membersTable.selectedHeaders.includes('membership_start_date_id_single')
											"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.membership_start_date != null">{{
												item.membership_start_date.date
											}}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="membersTable.selectedHeaders.includes('membership_valid_until_date')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.membership_until_display != null">{{
												item.membership_until_display
											}}</span>
											<span v-else>-</span>
										</td>
										<td
											v-if="membersTable.selectedHeaders.includes('membership_status_id_single')"
											@click="editClick(item.id, false)"
										>
											<span v-if="item.membership_status != null">{{
												item.membership_status.name
											}}</span>
											<span v-else>-</span>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-dialog v-model="bulkStatusChangeShow" width="50%" persistent>
			<v-card class="px-4 pt-4">
				<v-card-title> Grupna promjena statusa </v-card-title>
				<v-row class="ma-0 pa-0">
					<v-col cols="5" class="ml-5 pl-5">
						<CheckBox v-model="bulkStatusChangeStatusAll" :label="$t('fields.selectAll')"></CheckBox>
					</v-col>
				</v-row>
				<v-row class="ma-0 pa-0 justify-space-around">
					<v-col cols="5" class="d-flex justify-center">
						<DropdownMultiple
							v-model="bulkStatusChangeMembers"
							:ajax="true"
							:data="'members-candidates'"
							:clearable="true"
							label="Kandidati"
						></DropdownMultiple>
					</v-col>
					<v-col cols="5" class="d-flex justify-center">
						<Dropdown
							v-model="bulkStatusChangeStatus"
							:ajax="true"
							:data="'membership-statuses'"
							:clearable="true"
							label="Status"
						></Dropdown
					></v-col>
				</v-row>
				<v-row class="pt-10 pb-6 justify-space-around">
					<v-btn color="primary" @click="bulkStatusChangeSave">Spremi</v-btn>
					<v-btn @click="bulkStatusChangeClose">Odustani</v-btn>
				</v-row>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import Dropdown from '../../trinkets/Dropdown';
import TheTable from '../../trinkets/TheTable';
import CheckBox from '../../trinkets/CheckBox';
import DropdownMultiple from '../../trinkets/DropdownMultiple';

export default {
	name: 'Mebers',
	components: { TheTable, Dropdown, DropdownMultiple, CheckBox },
	data: function () {
		return {
			membersTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.member'),
						value: 'full_name',
						type: 'string',
						allowFilter: true,
						width: 500,
					},
					{ text: this.$t('fields.membershipId'), value: 'membership_id', type: 'string', allowFilter: true },
					{ text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true },
					{ text: this.$t('fields.contact'), value: 'phone_number', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.membershipBranch'),
						value: 'branch_id_single',
						type: 'dropdown|branches',
						allowFilter: true,
					},
					{
						text: this.$t('fields.magazine'),
						value: 'magazine_id_single',
						type: 'dropdown|magazines',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membersStartDate'),
						value: 'membership_start_date_id_single',
						type: 'dropdown|membership-start-dates',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membersEndDate'),
						value: 'membership_valid_until_date',
						type: 'date',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membershipStatus'),
						value: 'membership_status_id_single',
						type: 'dropdown|membership-statuses',
						allowFilter: true,
					},
				],
				additionalFilters: [
					{
						text: this.$t('fields.gender'),
						value: 'gender',
						type: 'dropdown|genders',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membershipBranch'),
						value: 'branch_id',
						type: 'multiple|branches',
						allowFilter: true,
					},
					{
						text: this.$t('fields.magazine'),
						value: 'magazine_id',
						type: 'multiple|magazines',
						allowFilter: true,
					},
					{
						text: this.$t('fields.cardIssued'),
						value: 'card_issued',
						type: 'dropdown|yes-no',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membersEndDate'),
						value: 'membership_valid_until_date',
						type: 'date_range',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membersStartDateRange'),
						value: 'membership_start_date',
						type: 'date_range',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membersStartDateDropdown'),
						value: 'membership_start_date_id',
						type: 'multiple|membership-start-dates',
						allowFilter: true,
					},
					{
						text: this.$t('fields.membershipStatus'),
						value: 'membership_status_id',
						type: 'multiple|membership-statuses',
						allowFilter: true,
					},
					{
						text: this.$t('fields.newsletterSignup'),
						value: 'newsletter_signup',
						type: 'dropdown|yes-no',
						allowFilter: true,
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'branch_id',
					descending: false,
				},
			},
			fastFilterCountry: 0,
			bulkStatusChangeShow: false,
			bulkStatusChangeMembers: [],
			bulkStatusCandidateNumber: 0,
			bulkStatusChangeStatusAll: false,
			bulkStatusChangeStatus: null,
		};
	},
	watch: {
		fastFilterCountry: {
			handler: function () {
				this.reloadData(this.membersTable.lastRequest);
			},
			deep: true,
		},
		bulkStatusChangeStatusAll: {
			handler: function () {
				if (this.bulkStatusChangeStatusAll) {
					if (this.bulkStatusChangeMembers.length != this.bulkStatusCandidateNumber) {
						this.selectAllCandidates();
					}
				}
			},
			deep: true,
		},
		bulkStatusChangeMembers: {
			handler: function () {
				if (this.bulkStatusChangeMembers.length != this.bulkStatusCandidateNumber) {
					this.bulkStatusChangeStatusAll = false;
				} else {
					this.bulkStatusChangeStatusAll = true;
				}
			},
			deep: true,
		},
	},
	methods: {
		selectAllCandidates() {
			this.$APICall(
				'get',
				'select/members-candidates',
				{},
				(data, success) => {
					if (success) {
						this.bulkStatusChangeMembers = data.map((item) => item.value);
					}
				},
				true
			);
		},
		getCandidatesNumber() {
			this.$APICall(
				'get',
				'select/members-candidates',
				{},
				(data, success) => {
					if (success) {
						this.bulkStatusCandidateNumber = data.length;
					}
				},
				true
			);
		},
		bulkStatusChangeClick() {
			this.bulkStatusChangeShow = true;
			this.getCandidatesNumber();
		},
		bulkStatusChangeClose() {
			this.bulkStatusChangeMembers = [];
			this.bulkStatusChangeStatus = null;
			this.bulkStatusChangeShow = false;
		},
		bulkStatusChangeSave() {
			this.$APICall(
				'post',
				'members-bulk-status',
				{ members: this.bulkStatusChangeMembers, status: this.bulkStatusChangeStatus },
				(data, success) => {
					if (success) {
						this.$notify('Statusi uspješno prebačeni');
						this.bulkStatusChangeClose();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		addClick() {
			this.$router.push('/members/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/members/' + id);
			} else {
				let routeData = this.$router.resolve('/members/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.membersTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.membersTable.lastRequest = request;
			request.fastFilterCountry = this.fastFilterCountry;
			let vm = this;
			this.$APICall(
				'get',
				'members',
				request,
				(data, success) => {
					if (success) {
						vm.membersTable.items = data.items;
						vm.membersTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.membersTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'members',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/members', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		resolveWindowResize() {
			this.membersTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.members'), href: '/#/members', disabled: true },
		]);
		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
